
import { Suspense,lazy } from "react";
import { Routes, Route} from "react-router-dom";
import Home from "../pages/HomePage";
import BrowseRooms from "../pages/BrowseRooms";
import ServicesPage from "../pages/ServicesPage";
import BlogPage from "../pages/BlogPage";
import ContactPage from "../pages/ContactPage";
import TermsofUses from "../pages/TermsofUses";
import FaqPage from "../pages/FaqPage";
import Partnership from "../pages/Partnership";
const AboutUsPage = lazy(() => import("../pages/AboutUsPage"))
const PageRoutes = () => {


    return (
        <>
  <Suspense fallback={<div>Loading...</div>}>
 
  
    <Routes>
     
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUsPage/>} />
        <Route path="/services" element={<ServicesPage/>}/>
        <Route path="/blog" element={<BlogPage/>}/>
        <Route path="/contact" element={<ContactPage/>}/>
        <Route path="/terms-of-use" element={<TermsofUses/>}/>
        <Route path="/faq" element= {<FaqPage/>}/>
        <Route path="/browse-rooms" element= {<BrowseRooms/>}/>  
        <Route path="/partnership" element={<Partnership/>}/>
       

        {/* <Route path =".features" element={<Features/>}/>
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/review" elemnt={<Review/>}/>
        <Route path="/contact" element={<Contact/>} /> */}
      
      </Routes>
   
  </Suspense>
        </>
    )
}
export default PageRoutes;